export const PREDICTIVE_REPORT_ID = 'predictive';
